export enum ScreenType {
  VIDEO_QUIZ = 'VIDEO_QUIZ',
  TIME_V2 = 'TIME_V2',
  DATE_PICKER_V2 = 'DATE_PICKER_V2',
  SPLIT = 'SPLIT',
  PRELANDING_PALMISTRY = 'PRELANDING_PALMISTRY',

  GOAL = 'GOAL',
  WHICH_FIGURE = 'WHICH_FIGURE',
  GOAL_SET = 'GOAL_SET',
  PLACE = 'PLACE',
  PLACE_NATAL_CHART = 'PLACE_NATAL_CHART',
  NAME_V2 = 'NAME_V2',
  FREE_INPUT_V2 = 'FREE_INPUT_V2',
  INFORMATIONAL_DYNAMIC = 'INFORMATIONAL_DYNAMIC',
  INFORMATIONAL_ANIMATED = 'INFORMATIONAL_ANIMATED',
  ANSWER = 'ANSWER',
  ANSWER_EMOJI = 'ANSWER_EMOJI',
  ANSWER_PALMISTRY = 'ANSWER_PALMISTRY',
  ANSWER_NATAL_CHART = 'ANSWER_NATAL_CHART',
  ANSWER_GOAL_NATAL_CHART = 'ANSWER_GOAL_NATAL_CHART',
  ANSWER_NATAL_CHART_V2 = 'ANSWER_NATAL_CHART_V2',
  ANSWER_DETAILED_OTHER = 'ANSWER_DETAILED_OTHER',
  ANSWER_HORIZONTAL_ORIENTATION = 'ANSWER_HORIZONTAL_ORIENTATION',
  ANSWER_HORIZONTAL_ORIENTATION_V2 = 'ANSWER_HORIZONTAL_ORIENTATION_V2',
  MULTIPLE_ANSWERS_V2 = 'MULTIPLE_ANSWERS_V2',
  PROBLEM = 'PROBLEM',
  EMAIL_V2 = 'EMAIL_V2',
  EMAIL_CONFIRM = 'EMAIL_CONFIRM',
  PROCESSING = 'PROCESSING',
  PROCESSING_PALMISTRY = 'PROCESSING_PALMISTRY',
  PROCESSING_NATAL_CHART = 'PROCESSING_NATAL_CHART',
  PROCESSING_LOADER = 'PROCESSING_LOADER',
  REVIEW = 'REVIEW',
  ONBOARDING = 'ONBOARDING',
  ONBOARDING_PALMISTRY = 'ONBOARDING_PALMISTRY',
  SCAN_PREVIEW = 'SCAN_PREVIEW',
  SCAN = 'SCAN',
  SCAN_ANALYSING = 'SCAN_ANALYSING',
  SCAN_ANALYSING_WITH_UPDATE_SETTINGS = 'SCAN_ANALYSING_WITH_UPDATE_SETTINGS',
  REPORT = 'REPORT',
  SINGLE_ZODIAC_INFO = 'SINGLE_ZODIAC_INFO',
  RELATIONSHIP_ZODIAC_INFO = 'RELATIONSHIP_ZODIAC_INFO',
  MENTIONED_IN = 'MENTIONED_IN',
  UPSELLS = 'UPSELLS',
  SOCIAL_PROOF = 'SOCIAL_PROOF',
  SOCIAL_PROOF_V2 = 'SOCIAL_PROOF_V2',
  UPSELL_CONSULTATION = 'UPSELL_CONSULTATION',
  UPSELLS_V2 = 'UPSELLS_V2',
  SUMMARY = 'SUMMARY',
  SUMMARY_V3 = 'SUMMARY_V3',
  TIMELINE = 'TIMELINE',
  LOADER_WITH_REVIEWS = 'LOADER_WITH_REVIEWS',
  UPSELLS_PALMISTRY_V2 = 'UPSELLS_PALMISTRY_V2',
  UPSELLS_NATAL_CHART = 'UPSELLS_NATAL_CHART',
  TRIAL_CREDITS = 'TRIAL_CREDITS',
  TRIAL_CREDITS_PALMISTRY = 'TRIAL_CREDITS_PALMISTRY',
  TRIAL_CREDITS_PALMISTRY_V2 = 'TRIAL_CREDITS_PALMISTRY_V2',
  TRIAL_CREDITS_NATAL_CHART = 'TRIAL_CREDITS_NATAL_CHART',
  ONBOARDING_ASK_V2 = 'ONBOARDING_ASK_V2',
  ZODIAC_CARD = 'ZODIAC_CARD',
  TRIAL_CHOICE = 'TRIAL_CHOICE',
  TRIAL_CHOICE_PALMISTRY_V2 = 'TRIAL_CHOICE_PALMISTRY_V2',
  TRIAL_PAYMENT_SECTIONS = 'TRIAL_PAYMENT_SECTIONS',
  TRIAL_PAYMENT_PAYWALL = 'TRIAL_PAYMENT_PAYWALL',
  TRIAL_PAYMENT_NATAL_CHART_SECTIONS = 'TRIAL_PAYMENT_NATAL_CHART_SECTIONS',
  PHONE_NUMBER_PALMISTRY = 'PHONE_NUMBER_PALMISTRY',
  GENDER = 'GENDER',
  GENDER_V2 = 'GENDER_V2',
  GENDER_V3 = 'GENDER_V3',
  GENDER_PALMISTRY = 'GENDER_PALMISTRY',
  MOON_PHASE = 'MOON_PHASE',
  LOADING_MOON_COMPATIBILITY = 'LOADING_MOON_COMPATIBILITY',
  PARTNER_MOON_PHASE = 'PARTNER_MOON_PHASE',
  HELLO_MOON_COMPATIBILITY = 'HELLO_MOON_COMPATIBILITY',
  THANK_YOU = 'THANK_YOU',
  CONTENT_REPRESENTATION_QUESTION = 'CONTENT_REPRESENTATION_QUESTION',
  EMAIL_MARKETING = 'EMAIL_MARKETING',
  EMAIL_MARKETING_ONE_TIME_PAYMENT = 'EMAIL_MARKETING_ONE_TIME_PAYMENT',
  /** @deprecated */
  EMAIL_MARKETING_COMPATIBILITY = 'EMAIL_MARKETING_COMPATIBILITY',
  EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT = 'EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT',
  RELATIONSHIP_PROGRESS = 'RELATIONSHIP_PROGRESS',
  /** @deprecated use TRIAL_PAYMENT_INTRO_OFFERS instead */
  TRIAL_PAYMENT_ATTACHMENT_STYLE_V3 = 'TRIAL_PAYMENT_ATTACHMENT_STYLE_V3',
  TRIAL_PAYMENT_INTRO_OFFERS = 'TRIAL_PAYMENT_INTRO_OFFERS',

  USER_AGE = 'USER_AGE',
  ANSWER_IMAGE = 'ANSWER_IMAGE',
  ANSWER_IMAGE_MULTIPLE = 'ANSWER_IMAGE_MULTIPLE',
  EMAIL_MARKETING_PAYWALL = 'EMAIL_MARKETING_PAYWALL',
  W2A_PROMOTION = 'W2A_PROMOTION',
  SCRATCH_CARD = 'SCRATCH_CARD',
  PRELANDING = 'PRELANDING',
  PRELANDING_VIDEO = 'PRELANDING_VIDEO',
  NATAL_CHART = 'NATAL_CHART',
  NATAL_CHART_REPORT = 'NATAL_CHART_REPORT',
  PERSONALIZED_ANIMATED_CARD = 'PERSONALIZED_ANIMATED_CARD',
  SIGNUP = 'SIGNUP',
  PURCHASE_LANDING = 'PURCHASE_LANDING',
  BEFORE_QUIZ_LANDING = 'BEFORE_QUIZ_LANDING',

  // TODO: add logic intitial screen check with policy and address
  NEB_ANSWER = 'NEB_ANSWER',
  NEB_ANSWER_RATING = 'NEB_ANSWER_RATING',
  NEB_MULTIPLE_ANSWERS = 'NEB_MULTIPLE_ANSWERS',
  NEB_UPSELLS = 'NEB_UPSELLS',
  NEB_INITIAL = 'NEB_INITIAL',

  NEB_SPLIT = 'NEB_SPLIT',
  NEB_INFORMATIONAL_DYNAMIC = 'NEB_INFORMATIONAL_DYNAMIC',
  NEB_EMAIL = 'NEB_EMAIL',
  NEB_EMAIL_CONFIRM = 'NEB_EMAIL_CONFIRM',
  // todo: add transition animation
  NEB_ONBOARDING = 'NEB_ONBOARDING',
  NEB_ASK_ONBOARDING = 'NEB_ASK_ONBOARDING',
  NEB_LOADER_WITH_CONTENT = 'NEB_LOADER_WITH_CONTENT',
  NEB_DATE = 'NEB_DATE',
  NEB_SCAN = 'NEB_SCAN',
  NEB_PHONE_NUMBER = 'NEB_PHONE_NUMBER',
  // check disableTimer prop
  NEB_TRIAL_PAYMENT = 'NEB_TRIAL_PAYMENT',
  NEB_W2A_PROMOTION = 'NEB_W2A_PROMOTION',
}
